import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fees-scholarships',
  templateUrl: './fees-scholarships.component.html',
  styleUrls: ['./fees-scholarships.component.scss']
})
export class FeesScholarshipsComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
